import { styled } from "styled-components";
import { Accordion } from "@mui/material";

export const StyledAccordion = styled(Accordion)`
	margin-top: 16px;

	&:before {
		content: none !important;
	}

	.accordionHeader {
		display: flex;
		align-items: center;
		font-weight: 600;

		span {
			background: #fff;
			padding-right: 20px;
			z-index: 5;
		}

		.accordionLine {
			display: inline-block;
			height: 1px;
			width: 70%;
			background-color: rgba(153, 153, 153, 0.5);
			margin-left: 10px;
			position: absolute;
			right: 4.5vw;
		}
	}
`;
